import type {CSSProperties,ReactNode} from 'react';
import {Ban,CircleCheck,CircleOff,ClipboardCheck,CreditCard,Eraser,Hand,HandCoins,Hourglass,Lock,Mail,MessageSquare,CirclePause,Plane,
 Scale,Tag,UserX,Zap} from 'lucide-react';
import type {JourneyAction} from '../../../../src/domain/policy/describe';

const tokenNames:Record<string,string>={'invoice.number':'number','invoice.due_on':'due date','invoice.issued_on':'issue date',
 'invoice.pay_link':'payment link','contact.name':'first name','sender.name':'sender name','sender.signature':'signature',
 'customer.name':'customer name','payment.amount':'payment amount','credit.amount':'credit amount','credit.memo_number':'memo no.',
 'customer.display_name':'customer','invoices.outstanding':'your invoice from {month} is outstanding',
 'statement.review':'review your current statement here','sender.billing_contact':'billing contact','stage.pay_by_date':'pay-by date',
 'stage.suspension_date':'suspension date'};
/** Template text with {{placeholders}} drawn as quiet tokens ("invoice number") instead of raw braces. */
export function Fill({text}:{text:string}){
 const parts=text.split(/(\{\{[^}]+\}\})/g);
 return <>{parts.map((part,i)=>{
  const match=/^\{\{\s*([^|}]+?)\s*(?:\|[^}]*)?\}\}$/.exec(part);
  if(!match)return part;
  const name=tokenNames[match[1]!]??match[1]!.replace(/^invoice\./,'').replaceAll(/[_.]/g,' ');
  return <span key={i} className="pj-token">{name}</span>;
 })}</>;
}

const actionIcons:Record<JourneyAction['kind'],ReactNode>={email:<Mail size={14} aria-hidden/>,task:<ClipboardCheck size={14} aria-hidden/>,
 slack:<MessageSquare size={14} aria-hidden/>,credit:<CreditCard size={14} aria-hidden/>,pause:<CirclePause size={14} aria-hidden/>,
 other:<Zap size={14} aria-hidden/>};
export const actionIcon=(kind:JourneyAction['kind'])=>actionIcons[kind];

const stopIcons:Record<string,ReactNode>={paid:<CircleCheck size={16} aria-hidden/>,void:<Ban size={16} aria-hidden/>,
 written_off:<Eraser size={16} aria-hidden/>,promise_active:<HandCoins size={16} aria-hidden/>,
 broken_promise:<Hourglass size={16} aria-hidden/>,
 dispute_open:<Scale size={16} aria-hidden/>,out_of_office:<Plane size={16} aria-hidden/>,wrong_contact:<UserX size={16} aria-hidden/>,
 manual:<Hand size={16} aria-hidden/>,customer_status:<CircleOff size={16} aria-hidden/>,tag:<Tag size={16} aria-hidden/>};
export const stopIcon=(kind:string)=>stopIcons[kind]??<CirclePause size={16} aria-hidden/>;

/** Icon-only lock; the legend above the timeline explains it, and screen readers hear the words. */
export function ApprovalLock({approval}:{approval:boolean}){
 if(!approval)return null;
 return <span className="pj-lock" title="Needs approval: a person approves this before it goes out"><Lock size={11} aria-hidden/>
  <span className="sr-only">Needs approval</span></span>;
}

/** Severity as 0..1, which the CSS turns into the calm-to-urgent colour ramp. */
export const pressure=(severity:number,max:number)=>({'--sev':String(max?Math.min(1,severity/max):0)}) as CSSProperties;
